import * as React from "react";

import "./pricing-link.scss";

import {cs} from "@Common/react/chain-services";

import {CheckShowPricing}  from "../../../../../common/check-show-pricing";
import {PricingTableModal} from "../../../../../common/pricing-table-modal/pricing-table-modal";

export const PricingLink = ({templateOptions}) => cs(
    ["pricingModal", ({}, next) => PricingTableModal({templateOptions, next})],
    ({pricingModal}) => (
        <div
            className="pricing-link-2e2"
            xd-qa-type="dropdown"
            xd-qa-name="Pricing Table"
            onClick={(e) => {
                e.stopPropagation();
                pricingModal.show();
            }}
        >
            Pricing Table
        </div>
    ),
);
